import React, { useState, useEffect } from 'react';
import { Maximize2 } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import './PhotoGallery.css'

const PhotoGallery = () => {
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  // Function to import all images from a directory
  useEffect(() => {
    const importAll = (r) => {
      return r.keys().map(r);
    };

    try {
      // This imports all image files from the public/images directory
      const importedImages = importAll(
        require.context('../assets/gallery', false, /\.(png|jpe?g|svg|webp)$/)
      );
      setImages(importedImages);
    } catch (error) {
      console.error("Error loading images:", error);
    }
  }, []);

  // Open full image view
  const openFullImage = (image) => {
    setSelectedImage(image);
  };

  // Close full image view
  const closeFullImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className="photo-gallery">
      <Helmet>
        <title>Folsom Microgreens - Photo Gallery</title>
        <link rel="canonical" href="https://www.folsommicrogreens.com/#/photogallery" />
        <meta name="description" content="Learn more about Folsom Microgreens through our photo gallery." />
        <meta name="keywords" content="photo gallery, Folsom Microgreens, microgreens, sustainable farming" />
      </Helmet>
      <h1>Photo Gallery</h1>
      
      <div className="product-grid">
        {images.map((image, index) => (
          <div 
            key={index} 
            className="product-item"
          >
            <div className="product-image-container">
              <img 
                src={image} 
                alt={`Folsom Microgreens — ${index + 1}`}
                className="product-image"
              />
              <div 
                className="product-image-overlay"
                onClick={() => openFullImage(image)}
              >
                <Maximize2 
                  className="product-image-zoom-icon" 
                  size={32} 
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Full Image Modal */}
      {selectedImage && (
        <div 
          className="full-image-modal"
          onClick={closeFullImage}
        >
          <div className="full-image-container">
            <img 
              src={selectedImage} 
              alt="Full view" 
              className="full-image"
            />
            <p className="full-image-instructions">
              Click anywhere to close
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;